import React from 'react';

class CreateChannel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: !props.width ? 16 : props.width,
      height: !props.height ? 12.8 : props.height,
      color: !props.color ? '#fff' : props.color,
    };
  }

  render() {
    return (
      <svg
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        width={this.state.width}
        height={this.state.height}
        viewBox={`0 0 ${this.state.width} ${this.state.height}`}>
        <path
          id="crown-solid"
          d="M13.2,11.2H2.8a.4.4,0,0,0-.4.4v.8a.4.4,0,0,0,.4.4H13.2a.4.4,0,0,0,.4-.4v-.8A.4.4,0,0,0,13.2,11.2Zm1.6-8a1.2,1.2,0,0,0-1.2,1.2,1.176,1.176,0,0,0,.11.495L11.9,5.98a.8.8,0,0,1-1.1-.29L8.757,2.125a1.2,1.2,0,1,0-1.515,0L5.205,5.69A.8.8,0,0,1,4.1,5.98L2.293,4.9A1.2,1.2,0,1,0,1.2,5.6a1.225,1.225,0,0,0,.193-.02L3.2,10.4h9.6l1.808-4.82a1.225,1.225,0,0,0,.192.02,1.2,1.2,0,1,0,0-2.4Z"
          fill={this.state.color}
        />
      </svg>
    );
  }
}

export default CreateChannel;
